// extracted by mini-css-extract-plugin
export var accent = "_bm-4";
export var add = "_bm-j";
export var addIcon = "_bm-k";
export var deleteIcon = "_bm-i";
export var disabled = "_bm-9";
export var ellipsis = "_bm-f";
export var error = "_bm-3";
export var form = "_bm-5";
export var hideFocus = "_bm-2";
export var icon = "_bm-7";
export var input = "_bm-e";
export var listItem = "_bm-h";
export var mediumHeight = "_bm-b";
export var noBorder = "_bm-8";
export var noRadius = "_bm-1";
export var shortHeight = "_bm-a";
export var tallHeight = "_bm-c";
export var textInput = "_bm-0";
export var vertical = "_bm-g";
export var veryTallHeight = "_bm-d";
export var widget = "_bm-6";